import React from 'react'

import BodyText from '../body-text/body-text.component'

import dayjs from 'dayjs'
import { useIntl } from 'react-intl'

const BodyRelativeTimestamp = ({ item }) => {
  const { timestamp } = item

  const intl = useIntl()

  const formatTime = timeData => {
    if (!timeData) {
      return 'Not provided'
    }

    const timeFormat = dayjs.unix(timeData.seconds).locale(intl.locale).fromNow()

    return timeFormat
  }

  const formattedItem = {
    ...item,
    text: formatTime(timestamp)
  }

  return <BodyText item={formattedItem} />
}

export default BodyRelativeTimestamp
